import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";

// Создание клиента для React Query

const queryClient = new QueryClient();

// Основной компонент приложения
const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      {/* Компоненты для отображения уведомлений */}
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          {/* Главная страница */}
          <Route path="/" element={<Index />} />
          {/* ДОБАВЬТЕ ВСЕ ПОЛЬЗОВАТЕЛЬСКИЕ МАРШРУТЫ ВЫШЕ УНИВЕРСАЛЬНОГО МАРШРУТА "*" */}
          {/* Страница 404 для всех остальных маршрутов */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
